import * as React from "react";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";

// Utils
import { FormatDate } from "../../../../utils/formatDate";
import { useTranslation } from 'react-i18next'
import { InputContainer, InputText } from "../SearchBarWorkflow/styles";

export const SearchBarLogs = ({ setArrayLogs, rows }) => {

    const { t } = useTranslation();
    const [search, setSearch] = React.useState('')
    const {format} = new FormatDate();

    function handleSearch(e) {
        setSearch(e)
        filterSearch(e)
    }

    const filterSearch = (data) => {
        let searchResults = rows.filter(e => {
            if (e.action?.toString().toLowerCase().includes(data.toLowerCase())
                || e.username?.toString().toLowerCase().includes(data.toLowerCase())
                || e.module?.toString().toLowerCase().includes(data.toLowerCase())
                || e.submodule?.toString().toLowerCase().includes(data.toLowerCase())
                || format(e.createdAt, true, true).toString().toLowerCase().includes(data.toLowerCase())
            ) {
                return e
            }
        })
        setArrayLogs(searchResults)
    }

    React.useEffect(() => {
        setArrayLogs(rows);
        handleSearch(search);
    }, [rows])


  return (
    <InputContainer
      component="form"
      elevation={0}
    >
      <IconButton type="button" sx={{ p: '5px' }} aria-label="search" disabled>
        <SearchIcon />
      </IconButton>
      <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
      <InputText
        type="text"
        name="search"
        value={search}
        onChange={(e) => handleSearch(e.target.value)}
        autoComplete="off"
        placeholder={t('system.logs.searchBar')}
        inputProps={{ "aria-label": "search google maps" }}
      />
    </InputContainer>
  );
};
